import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const FloatingBackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when scrolling down more than 300px
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="
        fixed bottom-36 left-4 md:bottom-22 md:left-4
        bg-blue-600 text-white
        rounded-full p-3
        shadow-lg shadow-black/20
        hover:bg-blue-700
        focus:outline-none focus:ring-2 focus:ring-blue-400
        transition-all duration-200 hover:scale-110
        z-40 group
      "
      aria-label="עלה למעלה"
    >
      <ArrowUp className="w-4 h-4" />
      <span className="absolute left-full top-1/2 -translate-y-1/2 ml-2 bg-white text-blue-600 px-2 py-1 rounded shadow-md text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        לתחילת העמוד
      </span>
    </button>
  );
};

export default FloatingBackToTopButton;